import { DataLayer } from '@grandvisionhq/analytics';

const pushImageGalleryItemExpandedEvent = (isExpanded)=>{
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'click',
        eventLabel: isExpanded ? 'show more' : 'show less'
    });
};
const pushImageGalleryOpenEvent = (altText, index, sku)=>{
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'open',
        eventLabel: `${sku} - ${altText} - ${index}`
    });
};
const pushImageGalleryZoomEvent = (altText, sku)=>{
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'zoom',
        eventLabel: `${sku} - ${altText}`
    });
};
const pushImageGalleryItemClickEvent = (index, sku, thumbnail)=>{
    const eventLabel = thumbnail.vto ? `${sku} - vto allow` : `${sku} - ${thumbnail.altText} - ${index}`;
    DataLayer.pushEvent({
        event: 'image gallery',
        eventAction: 'click',
        eventLabel
    });
};

export { pushImageGalleryItemClickEvent, pushImageGalleryItemExpandedEvent, pushImageGalleryOpenEvent, pushImageGalleryZoomEvent };
//# sourceMappingURL=ImageGalleryEvents.js.map
